import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { useShowEligibleInsiderMessaging } from "@faire/retailer-visitor-shared/hooks/insider/useShowEligibleInsiderMessaging";
import { NonBreaking } from "@faire/web--source/common/string";
import { Insider } from "@faire/web--source/slate/icons/InsiderIcon";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var InsiderBadge = function(param) {
    var className = param.className, small = param.small, showShortText = param.showShortText, showFreeDuties = param.showFreeDuties, showFreeShipping = param.showFreeShipping, insiderBadgeText = param.insiderBadgeText, shouldUseFallbackText = param.shouldUseFallbackText, isInsiderMarketingPage = param.isInsiderMarketingPage, viewPeteFunction = param.viewPeteFunction;
    var shouldUseInsiderBadgeText = !shouldUseFallbackText;
    return /*#__PURE__*/ _jsxs(StyledTypography, {
        className: className,
        variant: small ? {
            mobileAndAbove: "labelSansMedium",
            desktopAndAbove: "paragraphSansMedium"
        } : "paragraphSansMedium",
        children: [
            /*#__PURE__*/ _jsx(TextWrapper, {
                children: /*#__PURE__*/ _jsx(BadgeText, {
                    showShortText: showShortText,
                    showFreeDuties: showFreeDuties,
                    showFreeShipping: showFreeShipping,
                    insiderBadgeText: shouldUseInsiderBadgeText ? insiderBadgeText : undefined,
                    isInsiderMarketingPage: isInsiderMarketingPage,
                    viewPeteFunction: viewPeteFunction
                })
            }),
            "\xa0",
            /*#__PURE__*/ _jsx(InlineInsider, {
                small: true,
                color: Decorative.icon.teal,
                fill: Decorative.icon.teal,
                fontSize: "16px"
            })
        ]
    });
};
var InsiderBadgeText = function(param) {
    var insiderBadgeText = param.insiderBadgeText, viewPeteFunction = param.viewPeteFunction;
    var onVisibleRef = useDoActionWhenVisible(function() {
        viewPeteFunction === null || viewPeteFunction === void 0 ? void 0 : viewPeteFunction(insiderBadgeText);
    });
    return /*#__PURE__*/ _jsx("span", {
        ref: onVisibleRef,
        children: insiderBadgeText
    });
};
var BadgeText = function(param) {
    var showShortText = param.showShortText, showFreeDuties = param.showFreeDuties, showFreeShipping = param.showFreeShipping, insiderBadgeText = param.insiderBadgeText, isInsiderMarketingPage = param.isInsiderMarketingPage, viewPeteFunction = param.viewPeteFunction;
    var showEligibleInsiderMessaging = useShowEligibleInsiderMessaging().showEligibleInsiderMessaging;
    if (insiderBadgeText) {
        return /*#__PURE__*/ _jsx(InsiderBadgeText, {
            insiderBadgeText: insiderBadgeText,
            viewPeteFunction: viewPeteFunction
        });
    }
    if (showEligibleInsiderMessaging || isInsiderMarketingPage) {
        return /*#__PURE__*/ _jsx(BadgeNUXText, {
            showShortText: showShortText,
            showFreeDuties: showFreeDuties,
            showFreeShipping: showFreeShipping
        });
    }
    if (showShortText) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: "Insider"
        });
    }
    if (showFreeDuties && showFreeShipping) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "AY1Ic8",
            defaultMessage: [
                {
                    type: 0,
                    value: "Insider"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "shipping &"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "duties"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        });
    }
    if (showFreeShipping) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "GW8k+H",
            defaultMessage: [
                {
                    type: 0,
                    value: "Insider free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "shipping"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        });
    }
    if (showFreeDuties) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "elRPWv",
            defaultMessage: [
                {
                    type: 0,
                    value: "Insider free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "duties"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: "Insider"
    });
};
var BadgeNUXText = function(param) {
    var showShortText = param.showShortText, showFreeDuties = param.showFreeDuties, showFreeShipping = param.showFreeShipping;
    if (showFreeDuties && showFreeShipping) {
        return showShortText ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "55w1jD",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "shipping &"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "duties"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "XsKHWw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "shipping &"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "duties with Insider"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        });
    }
    if (showFreeShipping) {
        return showShortText ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "jW43nm",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "shipping"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "hyHxVx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "shipping with Insider"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        });
    }
    if (showFreeDuties) {
        return showShortText ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "VXM0ao",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "duties"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "3XlVh5",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free"
                },
                {
                    type: 1,
                    value: "nbsp"
                },
                {
                    type: 0,
                    value: "duties with Insider"
                }
            ],
            values: {
                nbsp: NonBreaking.space
            }
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: "Insider"
    });
};
var StyledTypography = styled(Typography).attrs({
    color: Decorative.shade.teal
}).withConfig({
    componentId: "sc-6237925d-0"
})([
    "white-space:nowrap;"
]);
var TextWrapper = styled.span.withConfig({
    componentId: "sc-6237925d-1"
})([
    "white-space:break-spaces;"
]);
var InlineInsider = styled(Insider).withConfig({
    componentId: "sc-6237925d-2"
})([
    "position:relative;top:4px;vertical-align:baseline;"
]);
